/* eslint-disable jsx-a11y/interactive-supports-focus */
import classNames from 'classnames';
import { HTMLAttributes } from 'react';
import { NAVIGATION_KEYS } from 'src/interfaces/enums';
import { stopKeyDownPropagation } from 'src/utils/browserUtils';
import styles from './styles.module.scss';

export interface IToggleProps extends HTMLAttributes<HTMLElement> {
  checked: boolean;
  onClick?: () => void;
  icon?: React.ReactNode;
  height?: number | string;
  width?: number | string;
}

const Toggle = ({
  checked,
  onClick,
  icon,
  height = '.875rem',
  width = '1.5rem',
  className,
  ...htmlProps
}: IToggleProps) => {
  return (
    <div
      style={{ height, width }}
      onClick={onClick}
      onKeyDown={(event) => stopKeyDownPropagation(event, { keys: [NAVIGATION_KEYS.SPACE] })}
      aria-checked={checked ? 'true' : 'false'}
      role='switch'
      className={classNames(styles.container, className, { [styles.checked]: checked })}
      {...htmlProps}
    >
      <div className={styles.toggle} />
      <div style={{ width: height }} className={styles.handle}>
        {icon}
      </div>
    </div>
  );
};

export default Toggle;
